import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconsModule } from "../icons/icons.module";
import { LaunchTimeComponentModule } from "../launch-time/launch-time.component.module";
import { UpcomingLaunchCard } from "./upcoming-launch-card.component";

@NgModule({
  imports: [
    // Common
    CommonModule,
    IconsModule,
    LaunchTimeComponentModule,
    RouterModule
  ],
  declarations: [UpcomingLaunchCard],
  exports: [UpcomingLaunchCard],
})
export class UpcomingLaunchCardComponentModule { }
